import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null,
  asyncs: {
  }
}, 'reservationLots');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'Lot', field: 'Lot', minWidth: 150 },
    { headerName: 'Reserved', field: 'ReservedQuantityDisplay', type: 'numericColumn', suppressSorting: true },
    { headerName: 'Description', field: 'LotDescription', suppressSorting: true }
  ],
  Data: []
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clear:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }

    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.salesOrderEnquiry.reservationLots,
  {
    Data: data => data.Data,
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  // Data: state => state.salesOrderEnquiry.reservationLots.data.Data,
  isLoading: state => state.salesOrderEnquiry.reservationLots.loading,
  gridOptions: state => state.salesOrderEnquiry.reservationLots.data.gridOptions,
  Columns: state => state.salesOrderEnquiry.reservationLots.data.Columns,
  Actions: state => state.salesOrderEnquiry.reservationLots.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)